import { apiSlice, STORAGE_KEY } from "../../../features/api/apiSlice";

// helper (same pattern as auth)
const notifyAuthUpdated = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("auth:updated"));
  }
};

export const applicationFeeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    initiateApplicationFee: builder.mutation<any, void>({
      query: () => ({
        url: "/payments/application/initiate",
        method: "POST",
      }),
    }),

    verifyApplicationFee: builder.query<any, string>({
      query: (reference) => ({
        url: `/payments/application/status/${reference}`,
        method: "GET",
      }),

      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data?.paid) {
            const raw = localStorage.getItem(STORAGE_KEY);
            const user = raw ? JSON.parse(raw) : null;

            if (user) {
              user.application_fee = true;
              localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
              notifyAuthUpdated();
            }
          }
        } catch {
          // ignore
        }
      },
    }),
  }),
});

export const {
  useInitiateApplicationFeeMutation,
  useLazyVerifyApplicationFeeQuery,
} = applicationFeeApi;
